import React, { Component } from 'react';
import './ProgramHeading.css';

export class ProgramHeading extends Component {
    render() {
      return <div>
        <span className="text-center">
          <h4 className=" programHeading">{this.props.text}</h4>
        </span>
        </div>;
    }
  }
